import { Nullable } from 'common-types';
import { useState, useCallback } from 'react';

const useOxTabs = (initialSelectedKey?: string) => {
  const [selectedKey, setSelectedKey] = useState(initialSelectedKey || '');

  const handleChange = useCallback(
    (_: Nullable<React.SyntheticEvent>, newKey: string) => {
      setSelectedKey(newKey);
    },
    [],
  );

  return {
    selectedKey,
    handleTabChange: handleChange,
  };
};

export default useOxTabs;
